import { useContext } from 'react';

import { FolioToggleContext, type FolioToggleContextValue } from '@/hooks/folio-toggle-context';

export function useFolioToggle(): FolioToggleContextValue {
  const context = useContext(FolioToggleContext);
  if (context === null) {
    throw new Error('useFolioToggle must be used within FolioToggleProvider');
  }

  return context;
}
